import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone } from 'react-icons/fa';
import { getSiteBilgileri } from '../services/api';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [ayar, setAyar] = useState(null);
  const location = useLocation();

  useEffect(() => {
    getSiteBilgileri()
      .then(res => setAyar(res.data))
      .catch(err => console.error(err));
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <span className="logo-karpat">KARPAT</span>
          <span className="logo-oto">OTOMOTİV</span>
        </Link>

        <div className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
          <Link to="/" className={`navbar-link ${isActive('/')}`} onClick={closeMenu}>
            Ana Sayfa
          </Link>
          <Link to="/hizmetler" className={`navbar-link ${isActive('/hizmetler')}`} onClick={closeMenu}>
            Hizmetler
          </Link>
          <Link to="/hakkimizda" className={`navbar-link ${isActive('/hakkimizda')}`} onClick={closeMenu}>
            Hakkımızda
          </Link>
          <Link to="/iletisim" className={`navbar-link ${isActive('/iletisim')}`} onClick={closeMenu}>
            İletişim
          </Link>
          <Link to="/randevu" className="navbar-link btn-randevu" onClick={closeMenu}>
            Randevu Al
          </Link>
        </div>

        <div className="navbar-phone">
          <FaPhone /> <a href={`tel:${ayar?.telefon?.replace(/\s/g, '') || '05320000000'}`}>{ayar?.telefon || '0532 000 00 00'}</a>
        </div>

        <div className="navbar-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
